module.exports = __webpack_public_path__ + "static/media/zl_2_7.4b1c9b9f.png";